import { render, staticRenderFns } from "./CericManageProposalForm.vue?vue&type=template&id=08fad425&scoped=true&"
import script from "./CericManageProposalForm.vue?vue&type=script&lang=js&"
export * from "./CericManageProposalForm.vue?vue&type=script&lang=js&"
import style0 from "./CericManageProposalForm.vue?vue&type=style&index=0&id=08fad425&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fad425",
  null
  
)

export default component.exports